// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__2xD8_","lds-dual-ring":"style_lds-dual-ring___89a8"};